class SectionedListControl {
	constructor(node, dataSource, config) {
		let{listElementParser,listParser,sortIndex,updateDispatchers,onClick,groupSort} = config;
		this._node = node;
		this._listElementParser = listElementParser;
		this._sortIndex = sortIndex;
		this._onClick = onClick;
		this._data  = listParser(dataSource);
		this._highlightedSectionTitles = [];
		this._ListSectionObjs = this._sortIntoGroupArrays(this._data, sortIndex,groupSort);
		if(onClick){
			node.addEventListener('click', this.handleClick.bind(this));
		}
		this.registerUpdateDispatchers(updateDispatchers);
		this.update();
	}

	registerUpdateDispatchers(updateDispatchers){
		if(!updateDispatchers){
			return;
		}
		
		for(var i = 0;i<updateDispatchers.length;i++){
			let updateDispatcher = updateDispatchers[i];
			updateDispatcher.addEventListener('update',this.update.bind(this));
		}

	}

	update(){
		let sectionedLists = this._buildSectionedists(
			this._ListSectionObjs,
			this._listElementParser
		);
		this.render(sectionedLists);
	}

	render(innerNodes) {
		this._node.innerHTML = '';
		for (var i = 0; i < innerNodes.length; i++) {
			var innerNode = innerNodes[i];
			this._node.appendChild(innerNode);
		}
			
	}

	clearSectionedListHighlights(){
		this._highlightedSectionTitles = [];

	}

	
	handleClick(e){
		let {target} = e;
		let secTitle = target.getAttribute('sec-title');
		let secKey = target.getAttribute('sec-key');
		let secValue = target.getAttribute('sec-value');
		let elValue = target.getAttribute('el-value');
		let elKey = target.getAttribute('el-key');
	
		if(secTitle){
			if(!this._highlightedSectionTitles[secValue]){
				this._highlightedSectionTitles[secValue] = true;
			}else{
				this._highlightedSectionTitles[secValue] = false;
			}
			for(var i = 0;i<this._ListSectionObjs.length;i++){
				if(this._ListSectionObjs[i].groupName === secValue){
					this._onClick.call(null,secKey,secValue,this._ListSectionObjs[i]);
					return;
				}
			}
			

		}else{
			this._onClick.call(null,elKey,elValue);
		}
	}

	_buildSectionedists(listObjs, listElementParser) {
		let sectionedLists = [];
		
		for(var i = 0; i<listObjs.length;i++){
			sectionedLists.push(
				this._buildSectionedList(
					listObjs[i],
					listObjs[i].groupName,
					listElementParser
				)
			);
		}

		
		return sectionedLists;
	}

	_buildSectionedList(listObj, sectionTitle, listElementParser) {
		
		let sectionedList = document.createElement('div');
		let sectionedListUl = document.createElement('ul');
		let sectionedListCaption = document.createElement('figcaption');
		
		sectionedList.classList.add('sectioned-list');
		sectionedListCaption.innerText = sectionTitle;
		sectionedListCaption.setAttribute('sec-title',true);
		sectionedListCaption.setAttribute('sec-key',this._sortIndex);
		sectionedListCaption.setAttribute('sec-value',sectionTitle);
		sectionedListUl.appendChild(sectionedListCaption);
		sectionedList.appendChild(sectionedListUl);

		if(this._highlightedSectionTitles[sectionTitle]){
			sectionedListCaption.classList.add('highlightedSection');
		}

		for (var i = 0; i < listObj.groupObj.length; i++) {
			let li =   listElementParser(listObj.groupObj[i]);     
			sectionedListUl.appendChild(li);
			
		}

		return sectionedList;
	}

	_sortIntoGroupArrays(objs, sortIndex,groupSort) {
		let sortedObjs = {};
		let sortedObjArr= [];
		for (let i = 0; i < objs.length; i++) {
			let obj = objs[i];
			let sortIndexValue = obj[sortIndex];
			if (sortedObjs[sortIndexValue] === undefined) {
				sortedObjs[sortIndexValue] = [];
			}
			sortedObjs[sortIndexValue].push(obj);
		}
		for(let sortedObjKey in sortedObjs){
			if(groupSort){
				sortedObjs[sortedObjKey].sort(groupSort)
			}
			sortedObjArr.push({
				groupName:sortedObjKey,
				groupObj:sortedObjs[sortedObjKey]
			});
			
		}

		
		sortedObjArr.sort((a,b)=>{
			let lowerA =a.groupName.toLowerCase();
			let lowerB =b.groupName.toLowerCase();

			if(lowerA==lowerB){
				return 0;
			}
			if(lowerA<lowerB){
				return -1;
			}
			return 1;
		});
		return sortedObjArr;
	}
}

export default SectionedListControl